import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';

import styles from './SplitView.module.css';
import Sidebar from './components/Sidebar';

const bindClasses = classNameBind.bind(styles);

class SplitView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leftSidebarVisible: true,
      rightSidebarVisible: true,
      leftSidebarWidth: null,
    };
  }

  sidebar = (side) => {
    const { leftSidebarVisible, rightSidebarVisible, leftSidebarWidth } = this.state;
    const { leftSidebar, rightSidebar } = this.props;
    if (side === 'left') {
      return (
        leftSidebarVisible
          ? (
            <div
              className={bindClasses('sidebar-view')}
              data-ppuc-id="SplitView.SidebarLeft"
            >
              <Sidebar
                resizable={leftSidebar.resizable}
                onResize={width => this.setState({ leftSidebarWidth: width })}
                initSize={leftSidebarWidth}
                styled={leftSidebar.styled}
              >
                {leftSidebar.sidebar}
              </Sidebar>
              {leftSidebar.canBeHideManually
                ? (
                  <div
                    className={bindClasses('sidebar-collapse-icon')}
                    onClick={() => this.setState({ leftSidebarVisible: false })}
                    role="button"
                    tabIndex={0}
                  >
                    <div className={bindClasses('collapse-icon-inactive')}>
                      <Icon name="sidebar-indicator" color="light-gray" />
                    </div>
                    <div className={bindClasses('collapse-icon-active')}>
                      <Icon name="sidebar-collapse" color="blue" />
                    </div>
                  </div>
                )
                : null
              }
            </div>
          )
          : (
            <div
              className={bindClasses('collapsed')}
              data-ppuc-id="SplitView.SidebarLeft.collapsed"
              onClick={() => (this.setState({ leftSidebarVisible: true }))}
              role="button"
              tabIndex={0}
            >
              <Icon name="chevron-right" color="gray" />
            </div>
          )
      );
    }

    return (
      rightSidebarVisible
        ? (
          <div
            className={bindClasses('sidebar-view')}
            data-ppuc-id="SplitView.SidebarRight"
          >
            <Sidebar>
              {rightSidebar.sidebar}
            </Sidebar>
            {rightSidebar.canBeHideManually
              ? (
                <div
                  className={bindClasses('sidebar-collapse-icon', 'right')}
                  onClick={() => this.setState({ rightSidebarVisible: false })}
                  role="button"
                  tabIndex={0}
                >
                  <div className={bindClasses('collapse-icon-inactive')}>
                    <Icon name="sidebar-indicator" color="light-gray" />
                  </div>
                  <div className={bindClasses('collapse-icon-active')}>
                    <Icon name="sidebar-collapse" color="blue" />
                  </div>
                </div>
              )
              : null
            }
          </div>
        )
        : (
          <div
            className={bindClasses('collapsed')}
            data-ppuc-id="SplitView.SidebarRight.collapsed"
            onClick={() => this.setState({ rightSidebarVisible: true })}
            role="button"
            tabIndex={0}
          >
            <Icon name="chevron-left" color="gray" />
          </div>
        )
    );
  }

  render() {
    const { leftSidebar, rightSidebar, children, dotsBackground } = this.props;

    return (
      <div
        className={bindClasses('container')}
        data-ppuc-id="SplitView"
      >
        {leftSidebar.sidebar && this.sidebar('left')}
        <div className={bindClasses('view', { dotsBackground })}>
          {children}
        </div>
        {rightSidebar.sidebar && this.sidebar('right')}
      </div>
    );
  }
}

SplitView.defaultProps = {
  leftSidebar: {},
  rightSidebar: {},
};

export default SplitView;
